<template>
  <div>
    <div class="wg-row" style="justify-content:center;">
      <input
        type="button"
        class="small"
        :value="$anm22.strLang(lang, 'Print', 'Stampa')"
        @click="print"
      />
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div id="print-div" class="only-print">
      <template v-if="!this.project.category || (this.project.category != 2)">
        <!-- INFORMAZIONI PROGETTO -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Details', 'Dettagli')"
        ></vircos-print-header>
        <vircos-data :projectId="projectId" :docs="docs" :mode="'view'"></vircos-data>
        <!-- MISURE ANATOMICHE -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Measurements', 'Misure')"
        ></vircos-print-header>
        <vircos-measures :projectId="projectId" :docs="docs" :mode="'view'"></vircos-measures>
        <template v-if="docs.measures.images">
          <template v-for="(img,index) in docs.measures.images.filter(i => i)">
            <vircos-print-header :key="'m-header-'+index" :projectId="projectId"></vircos-print-header>
            <img
              :key="'m-img-'+index"
              class="print-break-after"
              style="height:90%;width:90%;object-fit:contain;"
              :src="$anm22.getImagePath(img)"
            />
          </template>
        </template>
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Measures Sheet', 'Scheda misure')"
        ></vircos-print-header>
        <vircos-measures-sheet :projectId="projectId" :docs="docs" :sizes="sizes" :mode="'view'"></vircos-measures-sheet>
        <!-- INDICAZIONI DISEGNO -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Graphics', 'Disegno')"
        ></vircos-print-header>
        <vircos-graphics :projectId="projectId" :docs="docs" :mode="'view'"></vircos-graphics>
        <!-- TAGLIO -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Cutting', 'Taglio')"
        ></vircos-print-header>
        <vircos-cutting :projectId="projectId" :docs="docs" :mode="'view'"></vircos-cutting>
        <!-- LABORATORIO -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Lab', 'Laboratorio')"
        ></vircos-print-header>
        <vircos-lab :projectId="projectId" :docs="docs" :mode="'view'"></vircos-lab>
        <!-- FINITURA -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Finishing', 'Finitura')"
        ></vircos-print-header>
        <vircos-finishing :projectId="projectId" :docs="docs" :mode="'view'"></vircos-finishing>
        <!-- CONSEGNA -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Delivery', 'Consegna')"
        ></vircos-print-header>
        <vircos-delivery :projectId="projectId" :docs="docs" :mode="'view'"></vircos-delivery>
        <!-- BOZZA DISEGNO - IMMAGINI GRAPHICS -->
        <template v-if="docs.graphics.images">
          <template v-for="(img,index) in docs.graphics.images.filter(i => i)">
            <vircos-print-header :key="'g-header-1-'+index" :projectId="projectId"></vircos-print-header>
            <img
              :key="'g-img-1-'+index"
              class="print-break-after"
              style="height:90%;width:90%;object-fit:contain;"
              :src="$anm22.getImagePath(img)"
            />
            <vircos-print-header :key="'g-header-2-'+index" :projectId="projectId"></vircos-print-header>
            <img
              :key="'g-img-2-'+index"
              class="print-break-after"
              style="height:90%;width:90%;object-fit:contain;"
              :src="$anm22.getImagePath(img)"
            />
          </template>
        </template>
      </template>
      <template v-if="this.project.category && (this.project.category == 2)">
        <!-- INFORMAZIONI PROGETTO -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Details', 'Dettagli')"
        ></vircos-print-header>
        <vircos-data :projectId="projectId" :docs="docs" :mode="'view'"></vircos-data>
        <!-- MODIFICHE FITTING -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Fitting', 'Modifiche fitting')"
        ></vircos-print-header>
        <vircos-measures :projectId="projectId" :docs="docs" :mode="'view'"></vircos-measures>
        <template v-if="docs.measures.images">
          <template v-for="(img,index) in docs.measures.images.filter(i => i)">
            <vircos-print-header :key="'m-header-'+index" :projectId="projectId"></vircos-print-header>
            <img
              :key="'m-img-'+index"
              class="print-break-after"
              style="height:90%;width:90%;object-fit:contain;"
              :src="$anm22.getImagePath(img)"
            />
          </template>
        </template>
        <!-- MODIFICHE DISEGNO -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Graphics', 'Modifiche disegno')"
        ></vircos-print-header>
        <vircos-graphics :projectId="projectId" :docs="docs" :mode="'view'"></vircos-graphics>
        <!-- LABORATORIO -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Lab', 'Laboratorio')"
        ></vircos-print-header>
        <vircos-lab :projectId="projectId" :docs="docs" :mode="'view'"></vircos-lab>
        <!-- CONSEGNA -->
        <vircos-print-header
          :projectId="projectId"
          :title="$anm22.strLang(lang, 'Delivery', 'Consegna')"
        ></vircos-print-header>
        <vircos-delivery :projectId="projectId" :docs="docs" :mode="'view'"></vircos-delivery>
        <!-- BOZZA DISEGNO - IMMAGINI GRAPHICS -->
        <template v-if="docs.graphics.images">
          <template v-for="(img,index) in docs.graphics.images.filter(i => i)">
            <vircos-print-header :key="'g-header-1-'+index" :projectId="projectId"></vircos-print-header>
            <img
              :key="'g-img-1-'+index"
              class="print-break-after"
              style="height:90%;width:90%;object-fit:contain;"
              :src="$anm22.getImagePath(img)"
            />
            <vircos-print-header :key="'g-header-2-'+index" :projectId="projectId"></vircos-print-header>
            <img
              :key="'g-img-2-'+index"
              class="print-break-after"
              style="height:90%;width:90%;object-fit:contain;"
              :src="$anm22.getImagePath(img)"
            />
          </template>
        </template>
        <!-- SCHEDA RIPARAZIONE -->
        <template v-if="docs.lab.images">
          <template v-for="(img,index) in docs.lab.images.filter(i => i)">
            <vircos-print-header :key="'g-header-1-'+index" :projectId="projectId"></vircos-print-header>
            <img
              :key="'g-img-1-'+index"
              class="print-break-after"
              style="height:90%;width:90%;object-fit:contain;"
              :src="$anm22.getImagePath(img)"
            />
            <vircos-print-header :key="'g-header-2-'+index" :projectId="projectId"></vircos-print-header>
            <img
              :key="'g-img-2-'+index"
              class="print-break-after"
              style="height:90%;width:90%;object-fit:contain;"
              :src="$anm22.getImagePath(img)"
            />
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: {
      type: [Number, String]
    },
    docs: {
      type: Object
    },
    sizes: {
      type: Array
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      workSelected: state => state.workSelected
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    work() {
      return this.$store.getters["works/get"](this.workSelected);
    }
  },
  components: {
    VircosPrintHeader: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosPrintHeader.vue"),
    VircosData: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosData.vue"),
    VircosMeasures: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosMeasures.vue"),
    VircosGraphics: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosGraphics.vue"),
    VircosMeasuresSheet: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosMeasuresSheet.vue"),
    VircosCutting: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosCutting.vue"),
    VircosLab: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosLab.vue"),
    VircosFinishing: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosFinishing.vue"),
    VircosDelivery: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosDelivery.vue")
  },
  methods: {
    print() {
      const html = document.getElementById("print-div").cloneNode(true);

      // Get all stylesheets HTML
      const headElements = [],
        inserted = [];
      for (const node of [
        ...document.querySelectorAll('link[href$=".css"], style')
      ]) {
        // stylesHtml += node.innerHTML;
        if (node.tagName === "STYLE") {
          const elem = document.createElement("style");
          elem.type = "text/css";
          elem.innerHTML = node.innerHTML;
          headElements.push(elem);
        } else {
          if (!inserted.find(s => s === node.href)) {
            inserted.push(node.href);
            const elem = document.createElement("link");
            elem.type = "text/css";
            elem.rel = "stylesheet";
            elem.href = node.href;
            headElements.push(elem);
          }
        }
      }
      this.$anm22.print(html, headElements);
      this.$emit("closePrintDialog");
    }
  }
};
</script>

<style lang="scss" scoped>
.only-print {
  display: none !important;
}
@page {
  margin: 0cm !important;
}
@media print {
  html,
  body {
    background-color: #fff;
    -webkit-print-color-adjust: exact;
  }
  #print-div {
    background-color: #fff;
  }
  .only-print {
    display: block !important;
  }
  .vircos-header {
    flex-wrap: nowrap;
    align-items: center;
    padding: 10px 5px;
  }
  .print-break-after {
    break-after: page;
  }
  // .print-elem[type="text"] {
  //   // &[type="text"] {
  //     border-radius: 0;
  //     border: none;
  //     border-bottom: 1px solid #bbb;
  //   // }
  // }
}
</style>
<style lang="scss">
@media print {
  html, body {
    background-color: #fff;
    -webkit-print-color-adjust: exact;
  }
  .print-text {
    font-size: 10px !important;
    overflow: hidden;
  }
  .measures-sheet-container .suit-model {
    display: none;
  }
  .measures-sheet-container .input-row {
    height: auto !important;
  }
  input[type="text"], input[type="date"],input[type="number"],
  #print-div input[type="text"], #print-div input[type="date"],#print-div input[type="number"] {
    background-color: #fff!important;
  }
  .com-anm22-app-textarea, textarea
  #print-div .com-anm22-app-textarea, #print-div textarea {
    background-color: #fff;
  }
  .com-anm22-app-select, select
  #print-div .com-anm22-app-select, #print-div select {
    background-color: #fff;
  }
  .measures-sheet-container input[type="text"],input[type="number"]{
    padding: 3px 10px !important;
    height: auto !important;
    background-color: #fff;
  }
}
</style>